import React from 'react'
import './PageNotFound.css'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import Page from '../../Pages/Page/Page';

const PageNotFound = () => {
    return (
        <Page>
            <div className="container">
                <div className="page-not-found-main">
                    <FontAwesomeIcon icon={faExclamationTriangle} />
                    <h1>404</h1>
                    <h4>Page Not found</h4>
                    <Link to="/">Go Homepage</Link>
                </div>
            </div>
        </Page>
    )
}

export default PageNotFound
